import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLENGULFING', label: 'Engulfing', lookback: 2 })
